import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/authStore';
import { authService } from '../../services/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthState } = useAuthStore();
  const { t } = useTranslation(['auth']);
  const hasProcessed = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      // Prevent double processing in Strict Mode
      if (hasProcessed.current) {
        return;
      }
      hasProcessed.current = true;

      try {
        // 获取完整URL
        console.log('Full URL:', window.location.href);
        // 获取URL中的token参数
        console.log('window.location.search:', window.location.search);
        const token = new URLSearchParams(window.location.search).get('token');
        console.log('Received token:', token ? 'Token exists' : 'No token found');
        
        if (!token) {
          console.error('No token found in URL');
          message.error('Authentication failed: token not found');
          navigate('/login');
          return;
        }

        // 先存储token到localStorage，这样API调用才能正常工作
        localStorage.setItem('auth-storage', JSON.stringify({
          state: {
            token,
            isAuthenticated: true
          }
        }));

        // 获取用户信息
        try {
          const userResponse = await authService.getProfile();
          const user = userResponse.data;
          console.log('User profile:', user);

          // 更新认证状态，包含用户信息
          setAuthState({
            token,
            user,
            isAuthenticated: true
          });
        } catch (profileError) {
          console.error('Failed to get user profile:', profileError);
          // 如果获取用户信息失败，仍然存储token
          setAuthState({
            token,
            isAuthenticated: true
          });
        }

        // 登录成功时，首先清除所有sessionStorage缓存
        try {
          sessionStorage.clear();
          console.log('[Google登录] 已清除所有sessionStorage缓存');
        } catch (error) {
          console.warn('[Google登录] 清除sessionStorage缓存时出错:', error);
        }

        // 存储token到localStorage
        // localStorage.setItem('token', token);

        message.success(t('auth:login.login_success'));
        navigate('/');
      } catch (error) {
        console.error('认证回调处理失败:', error);
        message.error('Authentication failed, please try again');
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate, setAuthState]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <div>Processing authentication...</div>
      <div style={{ fontSize: '14px', color: '#666' }}>Please wait, completing the login process</div>
    </div>
  );
};

export default AuthCallback; 